<template>
  <div>
    <el-main>
      <ul>
        <li
          v-for="(it, idx) in orderList"
          :key="idx"
          class="news_item"
          @click="fnToArticle(it.info_id)"
        >
          <el-image :src="it.main_image" fit="cover"></el-image>
          <div class="news_item_info">
            <h3>{{ it.title }}</h3>
            <div class="news_item_time">
              <div>{{ $dayjs(it.publish_time).format("YYYY-MM-DD") }}</div>
              <!-- <div class="el-icon-view">{{ it.times }}</div> -->
            </div>
            <div class="news_item_desc" v-if="it.desctext">
              {{ it.desctext }}
            </div>
          </div>
        </li>
      </ul>
      <!-- <el-button type="info" @click="fnToGetMore()">點擊加載更多</el-button> -->
    </el-main>
  </div>
</template>
<script>
export default {
  data() {
    return {
      orderListRes: [],
      start: 0,
      limit: 5,
    };
  },
  props: {
    article_type: {
      type: String,
      default: "",
    },
  },
  computed: {
    orderList() {
      return this.orderListRes.map((item) => {
        try {
          item.main_image = this.$imgUrl + item.main_image;
        } catch (e) {}
        return item;
      });
    },
  },
  methods: {
    async getOrderList() {
      const { data: res } = await this.$http.get("/api/v2/investInfo/list", {
        params: {
          type: "order",
          association_id: 'SZTX'
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      this.orderListRes = [...this.orderListRes, ...res.data];
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    fnToGetMore() {
      this.start += this.limit;
      this.getOrderList();
    },
    fnToArticle(info_id) {
      console.log(info_id);
      this.$router.push({
        path: `/investInfo/${info_id}`,
      });
    },
  },
  created() {
    this.getOrderList();
  },
};
</script>
<style lang="less" scoped>
.el-button {
  width: 100%;
  font-size: 14px !important;
  color: #878787 !important;
  line-height: 22px !important;
  padding: 10px 0 !important;
  background: #fbfbfb !important;
  border: none !important;
}
.news_item {
  padding: 15px 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  .el-image {
    width: 200px;
    height: 120px;
    margin-right: 26px;
  }
  .news_item_info {
    // margin-top: 8px;
    flex: 1;
    h3 {
      font-size: 22px;
      line-height: 34px;
      color: #000;
      margin-bottom: 18px;
    }
    .news_item_time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      color: #333333;
      margin-right: 27px;
    }
    .news_item_desc {
      font-size: 14px;
      color: #414141;
      line-height: 22px;
      margin-top: 23px;
    }
    .el-icon-view:before {
      margin-right: 5px;
    }
  }
}
@media screen and (max-width: 768px) {
  .news_item {
    padding: 5px 20px;
    .el-image {
      width: 120px;
      height: 75px;
      margin-right: 12px;
      border-radius: 8px;
    }
    .news_item_info {
      h3 {
        font-size: 16px;
        line-height: 28px;
        color: #000;
        margin-bottom: 5px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      .news_item_time {
        font-size: 12px;
        color: #333333;
        margin-right: 10px;
      }
    }
  }
  .el-button {
    width: 80%;
    font-size: 14px;
    color: #878787;
    line-height: 22px;
    padding: 10px 0;
    background: #fbfbfb;
    border: none;
    margin: 10px auto;
    display: block;
  }
}
</style>
